import { create } from '@/shared/lib/zustand';
import { immer } from 'zustand/middleware/immer';
import type { PeriodSelectorState } from './types';

type GlobalPeriodState = {
  periodSelectorState: PeriodSelectorState;
};

type GlobalPeriodActions = {
  changePeriodSelectorState: (state: PeriodSelectorState) => void;
};

const initialState: GlobalPeriodState = {
  periodSelectorState: {
    dateRange: {},
    renderedDateRange: {},
  },
};

/**
 * The date range shown in the app header, shared by every page that used to own
 * a page-local copy (Facilities, Staff, Residents, Alerts, Facility).
 *
 * Market Intelligence keeps its own local period state — it uses a different
 * configuration (`monthsOnly`, From/To only, no 1M/6M/1Y) and can be disabled
 * per tab, so it cannot be driven by the header control.
 *
 * Not persisted: the range resets to the 1M default on reload, matching the
 * previous per-page behaviour.
 */
export const useGlobalPeriodStore = create<
  GlobalPeriodState & GlobalPeriodActions
>()(
  immer((set) => ({
    ...initialState,
    changePeriodSelectorState: (newPeriodSelectorState) => {
      set((state) => {
        state.periodSelectorState = newPeriodSelectorState;
      });
    },
  }))
);
